<nav class="breadcrumb-one" aria-label="breadcrumb">
  <ol class="breadcrumb">
    <li class="breadcrumb-item">
      <a href="javascript:void(0);">
        <svg class="feather feather-home" fill="none" height="24" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg">
          <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"></path>
          <polyline points="9 22 9 12 15 12 15 22"></polyline>
        </svg>
      </a>
    </li>
    <li class="breadcrumb-item active" aria-current="page" translate>Sub Accounts</li>
  </ol>
</nav>
<div [hidden]="loading" class="row layout-spacing layout-top-spacing bg-white shadow-lg py-4 rounded-sm" id="cancel-row">
  <div class="col-lg-12 text-right">
    <button type="button" class="btn btn-primary" (click)="openNewSubAccountModal()">{{ 'Add Sub Account' | translate }}
      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-plus-circle">
        <circle cx="12" cy="12" r="10"></circle>
        <line x1="12" y1="8" x2="12" y2="16"></line>
        <line x1="8" y1="12" x2="16" y2="12"></line>
      </svg>
    </button>
  </div>
  <div class="col-lg-12">
    <table *ngIf="subAccounts" class="w-100 mt-4 bg-white" cellpadding="5">
      <tr>
        <th translate>Name</th>
        <th translate>Mobile</th>
        <th translate>Gov Id</th>
        <th translate>Account Type</th>
        <th translate>Create Date</th>
        <th translate>Action</th>
      </tr>
      <tr *ngFor="let assignedSubAccount of subAccounts">
        <td [ngStyle]="getStyle(assignedSubAccount)" translate>{{ assignedSubAccount.fullName }}</td>
        <td [ngStyle]="getStyle(assignedSubAccount)" translate>{{ assignedSubAccount.mobile }}</td>
        <td [ngStyle]="getStyle(assignedSubAccount)" translate>{{ assignedSubAccount.govId }}</td>
        <td [ngStyle]="getStyle(assignedSubAccount)" translate>
          <input type="checkbox" [checked]="isAccountant(assignedSubAccount)" (change)="triggerAccountant(assignedSubAccount)"/>{{ 'Accountant' | translate }}&nbsp;&nbsp;
          <input type="checkbox" [checked]="isSales(assignedSubAccount)" (change)="triggerSales(assignedSubAccount)"/>{{ 'Sales' | translate }}
        </td>
        <td [ngStyle]="getStyle(assignedSubAccount)" translate>{{ assignedSubAccount.createDate | date:'YYYY-MM-dd' }}</td>
        <td translate>
          <button class="btn btn-outline-warning p-0" title="Lock account" (click)="lockSubAccount(assignedSubAccount)" *ngIf="assignedSubAccount.enabled">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="-3 0 32 32" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" class="feather feather-lock">
              <rect x="3" y="11" width="18" height="11" rx="2" ry="2"></rect>
              <path d="M7 11V7a5 5 0 0 1 10 0v4"></path>
            </svg>
          </button>
          <button class="btn btn-outline-success p-0" title="Unlock account" (click)="unlockSubAccount(assignedSubAccount)" *ngIf="!assignedSubAccount.enabled">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="-3 0 32 32" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" class="feather feather-unlock">
              <rect x="3" y="11" width="18" height="11" rx="2" ry="2"></rect>
              <path d="M7 11V7a5 5 0 0 1 9.9-1"></path>
            </svg>
          </button>
        </td>
      </tr>
    </table>
    <!--    <div class="widget-content searchable-container list my-2">-->
    <!--      <div class="searchable-items list">-->
    <!--        <div class="items items-header-section rounded-circle">-->
    <!--          <div class="item-content">-->
    <!--            <div>-->
    <!--              <h4 class="text-primary" style="margin-right: 0" translate>Name</h4>-->
    <!--            </div>-->
    <!--            <div class="user-govId">-->
    <!--              <h4 class="text-primary" style="margin-left: 3px;" translate>Gov Id</h4>-->
    <!--            </div>-->
    <!--            <div class="user-phone">-->
    <!--              <h4 class="text-primary" style="margin-left: 3px;" translate>Phone</h4>-->
    <!--            </div>-->
    <!--            <div class="user-request-no">-->
    <!--              <h4 class="text-primary" style="margin-left: 3px;" translate>Request No</h4>-->
    <!--            </div>-->
    <!--          </div>-->
    <!--        </div>-->
    <!--        <div *ngFor="let c of subAccounts" class="items rounded-circle">-->
    <!--          <div *ngIf="c.fullName || c.mobile" class="item-content">-->
    <!--            <div class="user-profile my-1">-->
    <!--              <div class="user-meta-info">-->
    <!--                <p class="user-name" [attr.data-name]="c.fullName">{{c.fullName}}</p>-->
    <!--              </div>-->
    <!--            </div>-->
    <!--            <div class="user-phone my-1">-->
    <!--              <p class="usr-ph-no" [attr.data-govId]="c.govId">{{c.govId}}</p>-->
    <!--            </div>-->
    <!--            <div class="user-phone my-1">-->
    <!--              <p class="usr-ph-no" [attr.data-phone]="c.mobile">{{c.mobile}}</p>-->
    <!--            </div>-->
    <!--            <div class="user-request-no my-1">-->
    <!--              <p class="usr-ph-no" [attr.data-request-no]="c.requestNo"><a [routerLink]="'/private/assign-sub-accounts/' + c.requestNo">{{c.requestNo}}</a></p>-->
    <!--            </div>-->
    <!--          </div>-->
    <!--        </div>-->
    <!--      </div>-->
    <!--    </div>-->
  </div>
</div>
<div *ngIf="loading">
  <div class="d-flex">
    <div class="mx-auto spinner-grow text-info align-self-center loader-lg"></div>
  </div>
</div>
<app-new-sub-account (onResponseReceived)="newSubAccountModalResponseReceived($event)" #newSubAccountModal></app-new-sub-account>
<app-sub-accounts-payment-form #subAccountsPaymentForm></app-sub-accounts-payment-form>
<div class="modal" #infoModal tabindex="-1">
  <div class="modal-dialog modal-dialog-centered modal-lg">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" translate>{{ modalTitle }}</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <p>{{ modalMsg }}</p>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-primary" data-dismiss="modal" translate>Close</button>
      </div>
    </div>
  </div>
</div>
